<template>
  <div>
    <b-card class="standardpage">

      <b-nav class="pt-2 ml-2 mb-2" small pills>
        <b-nav-item class="nav-pills-hover-effect border-secondary strong" small @click="ghold_reset">*EVENTS*
          <span :id="'ihold_count_total'" class="ml-1 badge badge-dark">{{ gtotal }}</span>
        </b-nav-item>
        <!-- {{ events }} -->
        <b-nav-item v-if="zevent.eventcode" class="nav-pills-hover-effect border-secondary" small
          v-for="(zevent, index) in events" :key="zevent"
          @click="agent = null; slac = [], eventcode = [zevent.eventcode]" :active="zevent.eventcode == eventcode[0]">
          <span :id="'event_name_' + index" :class="zevent.eventcode == '*BLOCKED*' ? 'strong text-danger' : null"
            v-html="zevent.eventcode"></span>
          <span :id="'event_count_' + index" class="ml-1 badge badge-dark">{{ zevent.count }}</span>

          <span v-if="parseFloat(zevent.aged) > 0" :id="'event_aged_' + index" class="ml-1 badge badge-danger">{{
            zevent.aged }}</span>

          <b-tooltip :target="'event_name_' + index" placement="top">{{ zevent.name }}</b-tooltip>

          <b-tooltip :target="'event_count_' + index" placement="top">{{ zevent.count }} line(s) in
            total.</b-tooltip>

          <b-tooltip :target="'event_aged_' + index" placement="top">{{ zevent.aged }} charge(s) have been delayed in
            Car Hire Inventory for
            longer
            than a
            week!</b-tooltip>
        </b-nav-item>
      </b-nav>
      <hr />

      <b-nav class="pt-2 ml-2 mb-2" small pills>
        <b-nav-item class="nav-pills-hover-effect border-secondary strong" small @click="ghold_reset">*SLACS*
          <span :id="'ihold_count_total'" class="ml-1 badge badge-dark">{{ gtotal }}</span>
        </b-nav-item>
        <b-nav-item v-if="zclient.slac" class="nav-pills-hover-effect border-secondary" small
          v-for="(zclient, index) in clients" :key="zclient"
          @click="agent = null; eventcode = []; slac = [zclient.slac]" :active="zclient.slac == slac[0]">
          <span :id="'slac_name_' + index" :class="zclient.slac == '*BLOCKED*' ? 'strong text-danger' : null"
            v-html="zclient.slac"></span>

          <span :id="'slac_count_' + index" class="ml-1 badge badge-dark">{{ zclient.count }}</span>

          <!-- <span :id="'slac_aged_' + index" class="ml-1 badge badge-danger">{{ zclient.aged }}</span> -->
          <span v-if="parseFloat(zclient.aged) > 0" :id="'slac_aged_' + index" class="ml-1 badge badge-danger">{{
            zclient.aged }}</span>

          <b-tooltip :target="'slac_name_' + index" placement="top">{{ zclient.name }}</b-tooltip>

          <b-tooltip :target="'slac_count_' + index" placement="top">{{ zclient.count }} line(s) in
            total.</b-tooltip>

          <b-tooltip :target="'slac_aged_' + index" placement="top">{{ zclient.aged }} charge(s) have been delayed in
            Car Hire Inventory for
            longer
            than a
            week!</b-tooltip>

        </b-nav-item>
      </b-nav>

      <hr />

      <b-card-header class="pt-2 pb-2">
        <b-row>
          <b-col cols="auto" v-if="!agents.find(o => o.agent == agent)">
            <span class="badge badge-dark text-2x pt-0 pb-1 ml-0">Select an agent to view inventory
              <span v-if="user.permissions.includes('carhire.admin')">
                <span v-if="status.includes('ready')">
                  <i class="fa fa-check-square-o text-primary ml-1"></i>
                  <span class="ml-1 text-white">Ready</span>
                </span>
                <span v-if="status.includes('pending')">
                  <i class="fa fa-hourglass-half text-warning ml-1"></i>
                  <span class="ml-1 text-white">Pending</span>
                </span>
              </span>
            </span>

          </b-col>
          <b-col cols="auto" class="text-right" v-else>

            <span class="badge badge-dark text-2x pt-0 pb-1"> {{agents.find(o => o.agent ==
              agent) ? agents.find(o => o.agent == agent).name : ""}}
              <span v-if="user.permissions.includes('carhire.admin')">
                <span v-if="status.includes('ready')">
                  <i class="fa fa-check-square-o text-primary ml-1"></i>
                  <span class="ml-1 text-white">Ready</span>
                </span>
                <span v-if="status.includes('pending')">
                  <i class="fa fa-hourglass-half text-warning ml-1"></i>
                  <span class="ml-1 text-white">Pending</span>
                </span>
              </span>
            </span>

          </b-col>
          <b-col class="text-right strong"> Count:
            <span id="ihold_ztotal" class="ml-1 badge badge-dark text-3x pt-0 pb-1">{{ ztotal }}</span>
            <b-tooltip target="ihold_ztotal" placement="top">Total of uninvoiced ghold inventory waiting.</b-tooltip>
          </b-col>
        </b-row>
      </b-card-header>

      <div v-if="!component" class="mt-4 availtable datatable">
        <b-row>
          <b-col>
            <b-avatar-group v-for="(zdepartment, gindex) in departments" :key="gindex" size="34px" overlap="0"
              class="inline mr-1 mt-1 ml-2 text-center p-1 avatar_dept avatarbadge">
              <span class="text-primary pt-2 mr-1">{{ zdepartment }}</span>
              <!-- border-dark px-2 strong -->
              <div v-for="(zagent, index) in agents.filter(a => a.department == zdepartment)" :key="index">
                <span @click="change_agent(zagent.agent)" :id="zagent.agent + '_' + zagent.department + '_1'">
                  <b-avatar class="mr-1 z-auto" :text="zagent.agent" :badge="zagent.count"
                    badge-variant="dark"></b-avatar>
                </span>
                <b-tooltip :target="zagent.agent + '_' + zagent.department + '_1'" placement="bottom">{{ zagent.name }}
                </b-tooltip>
              </div>

            </b-avatar-group>
          </b-col>
        </b-row>

        <b-row class="excelsheetbuttons " no-gutters>
          <b-col>
            <span class="small text-primary">{{ message_count }}</span> </b-col>
        </b-row>

      </div>

      <div v-if="!component" class="availtable datatable">


        <b-card v-if="ghold.filter" class="w-100pct mb-3">
          <b-card-body class="py-0">

            <b-row>
              <b-col cols="12" sm="6" md="4" xl="3">
                <b-form-group label-cols="12" label="Client SL A/C" label-size="sm" class="mb-0">
                  <b-input-group>
                    <treeselect placeholder="Select slac..." searchPromptText="Type at least 3 chars..." v-model="slac"
                      :clearable="true" :multiple="true" :async="true" :load-options="treeselect_loadSLAC"
                      :show-count="true" :flatten-search-results="true" :disable-branch-nodes="true" :matchKeys="['id']"
                      search-nested :disabled="readonly">
                      <div slot="value-label" slot-scope="{ node }">
                        {{ node.raw.id }}
                      </div>
                    </treeselect>
                  </b-input-group>
                </b-form-group>
              </b-col>
              <b-col cols="12" sm="6" md="4" xl="3">
                <b-form-group label-cols="12" label="Event" label-size="sm">
                  <treeselect placeholder="Select event..." searchPromptText="Type at least 4 chars..."
                    v-model="eventcode" :clearable="true" :multiple="true" :async="true"
                    :load-options="treeselect_loadEvent" :show-count="true" :flatten-search-results="true"
                    :disable-branch-nodes="true" :matchKeys="['id']" search-nested @select="treeselect">
                    <div slot="value-label" slot-scope="{ node }">
                      {{ node.raw.id }}
                    </div>
                  </treeselect>
                </b-form-group>
              </b-col>

              <b-col cols="12" sm="6" md="4" xl="3">
                <!-- <b-col cols="auto"> -->
                <b-form-group label-cols="12" label="Date Travel" label-size="sm">
                  <!-- :timePicker="true"
                      :timePicker24Hour="true" -->
                  <b-input-group>
                    <daterangepicker size="sm" ref="datetravel" v-model="datetravel" :opens="'right'"
                      :locale-data="locale_data" :ranges="locale_ranges" :showDropdowns="true" :linkedCalendars="true"
                      :single-date-picker="'range'">
                    </daterangepicker>
                    <b-input-group-append>
                      <b-button size="sm" variant="outline-secondary" :disabled="false" @click="
                        datetravel = {
                          startDate: null,
                          endDate: null,
                        }
                        ">
                        <i class="fa fa-remove"></i>
                      </b-button>
                    </b-input-group-append>
                  </b-input-group>
                </b-form-group>
              </b-col>

              <!-- <b-col cols="12" sm="6" md="4" xl="3">
                <b-form-group label-cols="12" label="Date Travel" label-size="sm">
                  <b-input-group>
                    <b-form-datepicker size="sm" v-model="datetravel" label-help hide-header locale="en-GB"
                      placeholder="Date Travel" :date-format-options="{
                        year: 'numeric',
                        month: 'numeric',
                        day: 'numeric',
                      }"></b-form-datepicker>
                    <b-input-group-append>
                      <b-button size="sm" variant="outline-secondary" :disabled="!datetravel" @click="datetravel = ''">
                        <i class="fa fa-remove"></i>
                      </b-button>
                    </b-input-group-append>
                  </b-input-group>
                </b-form-group>
              </b-col> -->
              <b-col cols="12" sm="6" md="4" xl="3">
                <!-- <b-form-group label="Type" label-for="type" label-cols="12">
                  <treeselect v-model="type" :clearable="true" :multiple="true" :options="options_type"
                    placeholder="Show all..."></treeselect>
                </b-form-group> -->
                <b-form-group label-cols="12" label="Type" label-size="sm">
                  <treeselect placeholder="Show all..." searchPromptText="Supplier Type..." v-model="type"
                    :clearable="true" :multiple="true" :options="options_suppliertype">
                  </treeselect>
                </b-form-group>
              </b-col>
              <b-col cols="12" sm="6" md="4" xl="3">
                <b-form-group label-cols="12" label="Supplier BL A/C" label-size="sm" class="mb-0">
                  <b-input-group>
                    <treeselect placeholder="Select blac..." searchPromptText="Type at least 3 chars..." v-model="blac"
                      :clearable="true" :multiple="true" :async="true" :load-options="treeselect_loadBLAC"
                      :show-count="true" :flatten-search-results="true" :disable-branch-nodes="true" :matchKeys="['id']"
                      search-nested :disabled="readonly">
                      <div slot="value-label" slot-scope="{ node }">
                        {{ node.raw.id }}
                      </div>
                    </treeselect>
                  </b-input-group>
                </b-form-group>
              </b-col>

              <b-col cols="12" sm="6" md="4" xl="3">
                <b-row>
                  <b-col>
                    <b-form-group label="RefNo ( Paste List )" label-for="id" label-cols="12">
                      <b-input-group class="z-0">
                        <b-form-tags input-id="referenceno" v-model="referenceno" tag-variant="primary" separator=" ,;"
                          placeholder="Paste RefNo (1000,1001,1002...)" size="sm" class="h-29" add-button-text="+"
                          add-on-change remove-on-delete add-button-variant="outline-primary"></b-form-tags>

                        <b-input-group-append>
                          <b-button size="sm" variant="outline-secondary" @click="referenceno = []">
                            <i class="fa fa-remove"></i>
                          </b-button>
                        </b-input-group-append>
                      </b-input-group>
                    </b-form-group>
                  </b-col>

                  <!-- <b-col>
                    <b-form-group label="ConfNo ( Paste List )" label-for="id" label-cols="12">
                      <b-input-group class="z-0">
                        <b-form-tags input-id="id" v-model="reference" tag-variant="primary" separator=" ,;"
                          placeholder="Paste ConfNo (511304589, 511304590...)" size="sm" class="h-29"
                          add-button-text="+" add-on-change remove-on-delete
                          add-button-variant="outline-primary"></b-form-tags>

                        <b-input-group-append>
                          <b-button size="sm" variant="outline-secondary" @click="reference = []">
                            <i class="fa fa-remove"></i>
                          </b-button>
                        </b-input-group-append>
                      </b-input-group>
                    </b-form-group>
                  </b-col> -->
                </b-row>
              </b-col>
              <b-col cols="12" sm="6" md="4" xl="3">
                <b-row>
                  <b-col>
                    <b-form-group label-cols="12" label="Cost (min)" label-size="sm">
                      <b-input-group>
                        <b-form-input size="sm" v-model="cost.min" :debounce="ghold.debounce" placeholder="(min)"
                          trim></b-form-input>
                        <b-input-group-append>
                          <b-button size="sm" variant="outline-secondary" :disabled="!cost.min"
                            @click="cost.min = null; cost.max = null">
                            <i class="fa fa-remove"></i>
                          </b-button>
                        </b-input-group-append>
                      </b-input-group>
                    </b-form-group>
                  </b-col>
                  <b-col>
                    <b-form-group label-cols="12" label="Cost (max)" label-size="sm">
                      <b-input-group>
                        <b-form-input size="sm" v-model="cost.max" :debounce="ghold.debounce" placeholder="(max)"
                          trim></b-form-input>
                        <b-input-group-append>
                          <b-button size="sm" variant="outline-secondary" :disabled="!cost.max"
                            @click="cost.max = null">
                            <i class="fa fa-remove"></i>
                          </b-button>
                        </b-input-group-append>
                      </b-input-group>
                    </b-form-group>
                  </b-col>
                </b-row>
              </b-col>


              <b-col cols="12" sm="6" md="4" xl="3" class="display-none">
                <b-form-group label-cols="12" label="Source" label-size="sm">
                  <treeselect placeholder="Select source..." v-model="mssql" :clearable="false"
                    :options="options_source" :show-count="true" :flatten-search-results="true"
                    :disable-branch-nodes="true" :matchKeys="['id']" search-nested>
                  </treeselect>
                </b-form-group>
              </b-col>

              <b-col cols="12" sm="6" md="4" xl="3" v-if="!user.permissions.includes('carhire.admin')">
                <b-form-group label-cols="12" label="Agent" label-size="sm">
                  <b-input-group>
                    <b-form-input size="sm" v-model="agent" placeholder="Agent" trim></b-form-input>
                    <b-input-group-append>
                      <b-button size="sm" variant="outline-secondary" :disabled="!agent" @click="agent = ''">
                        <i class="fa fa-remove"></i>
                      </b-button>
                    </b-input-group-append>
                  </b-input-group> </b-form-group>
              </b-col>

              <b-col cols="12" sm="6" md="4" xl="3" v-if="user.permissions.includes('carhire.admin')">
                <b-row>
                  <b-col>
                    <b-form-group label-cols="12" label="Agent" label-size="sm">
                      <b-input-group>
                        <b-form-input v-model="agent" placeholder="Agent" trim></b-form-input>
                        <b-input-group-append>
                          <b-button size="sm" variant="outline-secondary" :disabled="!agent" @click="agent = ''">
                            <i class="fa fa-remove"></i>
                          </b-button>
                        </b-input-group-append>
                      </b-input-group> </b-form-group>
                  </b-col>
                  <b-col>
                    <b-form-group label-cols="12" label="Status" label-size="sm">
                      <treeselect placeholder="Select status..." v-model="status" :multiple="true" :clearable="false"
                        :options="options_status" :show-count="true" :flatten-search-results="true"
                        :disable-branch-nodes="true" :matchKeys="['id']" search-nested>
                      </treeselect>
                    </b-form-group>
                  </b-col>
                </b-row>
              </b-col>
            </b-row>
          </b-card-body>
        </b-card>

        <!-- {{ ghold.groupbydeployment }} -->
        <div class="px-3 mt-2 mb-2">
          <e-table classdivtable="availtable datatable w-100pct" refid="ghold" :busy="ghold.busy" :icon="ghold.icon"
            :selectmode="'none'" :showtoolbar="true" :showfab="false" :showsheets="false" :showrowcount="true"
            :showautoadd="false" :showpages="true" :offset="ghold.offset" :limit="ghold.limit" :page="ghold.page"
            :toolbarlibrary="ghold.toolbarlibrary" :tools="ghold.tools" :badges="ghold.badges" :fields="ghold.fields"
            :items="ghold.items" @click="ghold_click" @select="ghold_select" @load="ghold_reload">
          </e-table>
        </div>
      </div>

      <div v-if="component">
        <component :is="component" :selection="ghold.selected" :config="cconfig" @discard="toolClick('discard')"
          @refresh="toolClick('refresh')"></component>
      </div>
      <b-card-footer>
        <b-row class="mt-2">
          <b-col><span class="small" v-html="message"></span> </b-col>
        </b-row>
      </b-card-footer>
    </b-card>
  </div>
</template>

<script>
import gql from "graphql-tag";

export default {
  name: "Chold",
  async mounted() {
    this.accessdenied();
    await this.ghold_reset()
  },
  watch: {
    async referenceno() {
      await this.ghold_load();
    },
    async reference() {
      await this.ghold_load();
    },
    async slac() {
      await this.ghold_load();
    },
    async blac() {
      await this.ghold_load();
    },
    async datetravel() {
      await this.ghold_load();
    },
    async type() {
      await this.ghold_load();
    },
    async eventcode() {
      await this.ghold_load();
    },
    async agent() {
      await this.ghold_load();
    },
    async status() {
      await this.ghold_load();
    },
    "cost.min": {
      immediate: true,
      async handler(newVal, oldVal) {
        if (!this.cost.max) { this.cost.max = this.cost.min }
        await this.ghold_load(0)
      }
    },
    "cost.max": {
      immediate: true,
      async handler(newVal, oldVal) {
        await this.ghold_load(0)
      }
    },
  },

  data() {
    return {
      busy: false,
      message: "",
      gtotal: 0,
      ztotal: 0,
      events: [],
      clients: [],
      agents: [],
      departments: [],
      options_departments: [],
      email: "",
      agent: "",
      fullname: "",
      message_count: "",
      isblocked: "0",
      showblocked: false,
      readonly: false,
      eventcode: [],
      slac: [],
      blac: [],
      // datetravel: null,
      datetravel: {
        startDate: null,
        endDate: null,
      },
      type: [],
      options_suppliertype: [],
      options_type: [
        { id: "AIR", label: "Air Ticketed" },
        { id: "LOW", label: "Low Cost" },
        { id: "HTL", label: "Hotels" },
        { id: "CAR", label: "Cars" },
        { id: "XFR", label: "Transfers" },
        { id: "RAI", label: "Rail/Eurostar" },
        { id: "BAG", label: "Baggage" },
        { id: "MTG", label: "Meetings" },
        { id: "OTH", label: "Other" },
        // { id: "BMD", label: "Business" },
        // { id: "visa", label: "Visa" },
      ],
      referenceno: [],
      reference: [],
      agent: null,
      mssql: true,
      cost: {
        min: null,
        max: null,
      },
      status: ["ready"],
      options_status: [
        { id: "ready", label: "Ready" },
        { id: "pending", label: "Pending" },
        { id: "offline", label: "Offline" },
      ],
      ghold: {
        title: "Ground Handling",
        icon: "fa fa-bus text-dark",
        debounce: 1000,
        busy: false,
        page: 1,
        offset: 0,
        limit: 15,
        filter: false,
        tools: "go,filter",
        toolbarlibrary: [
          {
            type: "button",
            size: "sm",
            variant: "outline-white",
            squared: "squared",
            icon: "fa fa-check-square-o text-primary",
            position: "toolbar",
            action: "ready",
            label: "Ready",
            component: {
              name: "",
            },
          },
        ],
        fields: [
          {
            key: "citem",
            label: "Ghold Inventory",
            type: "iginvoice",
            class: "text-left w-90pct",
            clearable: "true",
          },
        ],
        badges: [],
        items: [],
        selected: [],
      },
    };
  },
  async mounted() {
    await this.accessdenied();
    try {
      const response = await this.$apollo.query({
        query: gql`
                        query suppliertypes {
                        suppliertypes {
                            id
                            label
                            faicon
                        }
                        }
                    `,
      });
      // this.options_suppliertype = response.data.suppliertypes;
      this.options_suppliertype = response.data.suppliertypes.filter(o => o.faicon != '');
    } catch (error) {
      console.log(error);
    }
    await this.ghold_load(0);
  },
  methods: {
    accessdenied() {
      this.ghold.denied = [];
      if (!this.user.permissions.includes("ghold.delete")) {
        this.ghold.denied.push("delete");
      }
      if (!this.user.permissions.includes("ghold.save")) {
        this.ghold.denied.push("save");
      }
      if (this.user.permissions.includes("carhire.admin")) {
        this.ghold.tools = "go,filter,ready,pending,reset"
      }
    },
    async change_agent(agent) {
      this.agent = agent
      await this.ghold_load();
    },
    async ghold_reset() {
      let state = this.ghold;
      state.items = []
      this.eventcode = []
      this.slac = []
      this.agent = null
      this.gtotal = 0
      await this.ghold_events_load()
      await this.ghold_clients_load()
      await this.ghold_agents_load()
    },
    async ghold_reload() {
      await this.ghold_events_load()
      await this.ghold_clients_load()
      await this.ghold_agents_load()
      await this.ghold_load();
    },
    async ghold_agents_load() {
      let variables = {
        type: 'byagent',
        source: 'ghold',
        status: this.status.length > 0 ? this.status.join(",") : null,
        blac: this.blac.length > 0 ? this.blac.join(",") : null,
        eventcode: this.eventcode ? this.eventcode.join(",") : null,
        slac: this.slac ? this.slac.join(",") : null,
      };
      console.log("variables", variables);
      try {
        const response = await this.$apollo.query({
          query: gql`
                query ihold_counts(
                    $type: String
                    $status: String
                    $source: String
                    $blac: String
                    $eventcode: String
                    $slac: String
                ) {
                  ihold_counts(
                      type: $type
                      source: $source
                      status: $status
                      blac: $blac
                      eventcode: $eventcode
                      slac: $slac
                ) {
                    count
                    agent
                    email
                    name
                    department
                }
                }
            `,
          variables,
        });

        this.agents = response.data.ihold_counts;

        this.departments = [...new Set(this.agents.map(a => a.department))].sort()

        this.ztotal = 0
        for (var i = 0; i < this.agents.length; ++i) {
          this.ztotal += parseInt(this.agents[i].count)
        }
      } catch (error) {
        console.log(error);
      }
    },
    async ghold_events_load() {
      let variables = {
        type: 'byevent',
        source: 'ghold',
        status: this.status.length > 0 ? this.status.join(",") : null,
        blac: this.blac.length > 0 ? this.blac.join(",") : null,
        agent: this.agent ? this.agent : null,
      };
      console.log("variables", variables);
      try {
        const response = await this.$apollo.query({
          query: gql`
                query ihold_counts(
                  $type: String
                  $source: String
                  $status: String
                  $blac: String
                  $agent: String
                ) {
                  ihold_counts(
                    type: $type
                    source: $source
                    status: $status
                    blac: $blac
                    agent: $agent
                ) {
                    count
                    aged
                    eventcode
                    name
                }
              }
            `,
          variables,
        });

        this.events = response.data.ihold_counts;

      } catch (error) {
        console.log(error);
      }
    },
    async ghold_clients_load() {
      let variables = {
        type: 'byclient',
        source: 'ghold',
        status: this.status.length > 0 ? this.status.join(",") : null,
        blac: this.blac.length > 0 ? this.blac.join(",") : null,
        agent: this.agent ? this.agent : null,
      };
      console.log("variables", variables);
      try {
        const response = await this.$apollo.query({
          query: gql`
                query ihold_counts(
                  $type: String
                  $source: String
                  $status: String
                  $blac: String
                  $agent: String
                ) {
                  ihold_counts(
                    type: $type
                    source: $source
                    status: $status
                    blac: $blac
                    agent: $agent
                ) {
                    count
                    aged
                    slac
                    name
                }
                }
            `,
          variables,
        });

        this.clients = response.data.ihold_counts;

        this.ztotal = 0
        for (var i = 0; i < this.clients.length; ++i) {
          this.ztotal += parseInt(this.clients[i].count)
        }
        if (!this.agent) {
          this.gtotal = this.ztotal
        }

      } catch (error) {
        console.log(error);
      }
    },
    async ghold_load(offset, limit, page) {

      if (this.events.length == 0) { await this.ghold_events_load() }
      if (this.clients.length == 0) { await this.ghold_clients_load() }
      if (this.agents.length == 0) { await this.ghold_agents_load() }

      let state = this.ghold;

      if (offset || offset == 0) {
        state.offset = offset
      }
      if (limit || limit == 0) {
        state.limit = limit
      }
      if (page) {
        state.page = page
      }

      //NO WILDCARD SEARCHES
      if (
        !this.agent && this.slac.length == 0 && this.eventcode.length == 0
      ) {
        this.message = ""
        return;
      }

      state.busy = true;

      let variables = {
        offset,
        limit: limit ? limit : this.limit,
        eventcode: this.eventcode.length > 0 ? this.eventcode.join(",") : null,
        slac: this.slac.length > 0 ? this.slac.join(",") : null,
        blac: this.blac.length > 0 ? this.blac.join(",") : null,
        reference: this.reference.length > 0 ? this.reference.join(",") : null,
        referenceno: this.referenceno.length > 0 ? this.referenceno.join(",") : null,
        status: this.status.length > 0 ? this.status.join(",") : null,
        type: this.type.length > 0 ? this.type.join(",") : null,
        datetravel: [
          this.datetravel.startDate
            ? this.$moment(this.datetravel.startDate).format("YYYY-MM-DD")
            : null,
          this.datetravel.endDate
            ? this.$moment(this.datetravel.endDate).format("YYYY-MM-DD")
            : null,
        ],
        agent: this.agent,
        source: 'ghold',
        cost: this.cost.min ? [this.cost.min, this.cost.max] : null,
      };

      console.log("variables", variables);
      try {
        const response = await this.$apollo.query({
          query: gql`
              query ihold(
                $offset: Int
                $limit: Int
                $groupby: String
                $eventcode: String
                $slac: String
                $blac: String
                $type: String
                $datetravel: [String]
                $referenceno: String
                $reference: String
                $status: String
                $source:String
                $agent: String
                $cost: [String]
              ) {
                ihold(
                  offset: $offset
                  limit: $limit
                  groupby: $groupby
                  eventcode: $eventcode
                  slac: $slac
                  blac: $blac
                  type: $type
                  datetravel: $datetravel
                  referenceno: $referenceno
                  reference: $reference
                  status: $status
                  source: $source
                  agent: $agent
                  cost: $cost
                ) {
                  id
                  referenceno
                  blac                  
                  eventcode
                  eventname
                  slac
                  slacname
                  yourref
                  cost
                  sale
                  vat
                  margin
                  markup
                  total
                  invoiceno
                  posted
                  notes
                  agent
                  lines {
                    id
                    type
                    issued_at
                    last4
                    referenceno                    
                    reference
                    routing
                    remark               
                    locator
                    start_at
                    end_at
                    details
                    description
                    passenger
                    qty
                    sale
                    vat
                    markup
                    total
                    costlocal
                    costlocalcurrency
                    costcurrency                
                    cost
                    blinvoiceno
                    blac
                    slac
                    eventcode
                    margin
                    agent
                    agentname
                    notes
                    expanded
                    claimed
                  }
                  tags
                  data
                  groupby
                  rows
                }
              }
            `,
          variables,
        });

        // USE LOCAL VARIABLE
        if (limit == 0) {
          state.selected = response.data.ihold
        } else {
          state.items = []
          // STABLE ROW IDENTITY (tp_server#20): key each row by its line ids so
          // e-table keys rows by record, not position - prevents inline-editor
          // state bleeding onto other rows when paging.
          response.data.ihold.forEach(row => {
            let ids = [];
            (row.lines || []).forEach(l => { if (l.id != null) ids.push(l.id); });
            row.uid = [...new Set(ids)].sort().join('-');
          });
          state.items = response.data.ihold;
        }

      } catch (error) {
        console.log(error);
      }

      await this.ghold_clients_load()
      await this.ghold_agents_load()

      state.busy = false;
    },

    async ghold_click(a, ss, tools) {
      console.log("ghold_click", a, ss, tools);

      let tool = null

      switch (a) {
        case "filter":
          this.ghold.filter = !this.ghold.filter;
          break;
        case "back":
          this.discard();
          break;
        case "save":
          this.saveit();
          break;
        case "posted":
          this.postit(ss);
          break;
        case "go":
          await this.ghold_reload()
          this.$store.dispatch("ghold");
          break;
        case "ready":
          this.status = ['ready']
          await this.ghold_reload()
          break;
        case "pending":
          this.status = ['pending']
          await this.ghold_reload()
          break;
        case "reset":
          this.status = ['ready']
          this.blac = []
          this.slac = []
          this.eventcode = []
          await this.ghold_reload()
          break;
      }
    },
    async ghold_select(ss, tools) {
      console.log("ghold_select", ss);

      let tool = null;

      if (tools) {
        let enabled = ["back", "save", "go", "filter", "export", 'ready', 'pending', 'reset'];
        enabled.forEach(function (action, index) {
          tool = tools.find((o) => o.action == action);
          if (tool) {
            tool.disabled = false;
          }
        });

        tool = tools.find((o) => o.action == "deleteconfirm");
        if (tool) {
          tool.disabled = ss.length > 0 ? false : true;
        }
        tool = tools.find((o) => o.action == "notes");
        if (tool) {
          tool.disabled = ss.length == 1 ? false : true;
        }
      }

      this.ghold.selected = ss;
    },
    async postit(s) {
      console.log("postit", s);
      s[0].posted = true
      await this.ghold_clients_load()
      this.$store.dispatch("ghold");
    },

  },
};
</script>